module.exports = __webpack_public_path__ + "static/img/在线缴费@3x.8aac1cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/nav/在线缴费@3x.png
// module id = 799
// module chunks = 382